import type { Article, CategoryMeta } from '@/types/article';

export const categories: CategoryMeta[] = [
  {
    slug: 'entertainment',
    name: '娱乐黑料',
    icon: 'ri-fire-line',
    description: '综艺内幕、番位之争、资本博弈与行业潜规则，带你直击娱乐工业背后的真实生态。',
  },
  {
    slug: 'star',
    name: '明星爆料',
    icon: 'ri-star-smile-line',
    description: '恋情曝光、人设反转、合约纠纷与私生活风波，第一时间追踪明星动态的每一个关键节点。',
  },
  {
    slug: 'society',
    name: '社会热点',
    icon: 'ri-earth-line',
    description: '食品安全、职场内幕、消费维权与城市公共事件，关注那些与你我生活息息相关的热点。',
  },
];

export const allTags: string[] = [
  '顶流塌房',
  '恋情曝光',
  '人设崩塌',
  '资本博弈',
  '番位之争',
  '私生饭',
  '代拍乱象',
  '网络暴力',
  '食品安全',
  '职场内幕',
  '消费维权',
  '城市热点',
  '天价片酬',
  '塌房预警',
  '离婚风波',
];

export const articles: Article[] = [
  {
    id: '100001',
    title: '顶流男星片场耍大牌风波升级，多位工作人员实名爆料',
    excerpt:
      '一位近期因热播剧爆红的顶流男星被多名剧组工作人员实名爆料，称其长期迟到、拒绝配合通告，甚至当众训斥场务，事件持续发酵。',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20editorial%20photography%20of%20a%20cone%20of%20dramatic%20warm%20orange%20stage%20light%20cutting%20through%20dark%20charcoal%20haze%20with%20floating%20dust%20particles%2C%20moody%20cinematic%20contrast%2C%20minimal%20clean%20composition%20suitable%20for%20a%20news%20article%20cover&width=800&height=500&seq=blackliao-news-01&orientation=landscape',
    content: [
      '一条关于某位顶流男星在片场耍大牌的爆料帖在社交平台迅速传播。发帖者自称是剧组场务，附上了拍摄通告单与现场手记的照片，虽然关键信息已做模糊处理，但时间线与剧组公开行程高度吻合。',
      '爆料中提到，该男星在拍摄期间多次迟到，最长一次让整个团队等待近三个小时。更让工作人员难以接受的是，他曾在现场当众训斥负责调度的工作人员，语气激烈，导致拍摄一度中断。',
      '截至发稿，男方工作室尚未对此事作出正面回应，仅通过经纪人表示“相关情况正在核实”。然而已有两家合作品牌悄悄下架了与该男星相关的宣传物料，被外界解读为观望信号。',
      '业内人士分析，此类片场风波的杀伤力往往不在于事件本身，而在于它是否会引发更多从业者跟风爆料。一旦形成“滚雪球”效应，艺人多年经营的形象可能在数日内崩塌。',
    ],
    category: '娱乐黑料',
    categorySlug: 'entertainment',
    tags: ['顶流塌房', '职场内幕', '塌房预警'],
    source: '黑料观察室',
    publishTime: '2026-10-15T09:20:00',
    views: 186420,
  },
  {
    id: '100002',
    title: '人气女演员与神秘男子深夜同框，恋情传闻再度升温',
    excerpt:
      '有网友在市中心一家私房菜馆外拍到人气女演员与一名男子深夜同行，两人举止自然亲密，疑似恋情曝光，工作室暂未回应。',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20night%20city%20bokeh%20photography%20with%20warm%20amber%20street%20lights%20blurring%20into%20soft%20circles%20against%20a%20deep%20charcoal%20background%2C%20romantic%20cinematic%20mood%2C%20elegant%20minimal%20composition%20for%20an%20entertainment%20news%20cover&width=800&height=500&seq=blackliao-news-02&orientation=landscape',
    content: [
      '据多位网友爆料，某人气女演员在周五深夜现身市中心一家不对外开放的私房菜馆，同行者是一名佩戴口罩与棒球帽的男子。两人从后门离开时被路人拍下，画面虽模糊但仍可辨认身形。',
      '知情人透露，该男子并非圈内人士，而是一位从事艺术品投资的商人，两人通过共同好友介绍认识，交往已有一段时间。此前女演员在采访中曾表示“现阶段更专注作品”，被粉丝认为是间接否认。',
      '消息传出后，女演员的社交账号评论区迅速被“求回应”刷屏。其工作室在数小时后发布了一条无关的工作动态，被解读为刻意冷处理。',
      '娱乐观察人士指出，艺人对恋情传闻的处理方式往往背后有完整的公关策略，沉默、否认或官宣各有代价，最终决定权通常不只掌握在艺人本人手中。',
    ],
    category: '明星爆料',
    categorySlug: 'star',
    tags: ['恋情曝光', '顶流塌房'],
    source: '娱乐深喉',
    publishTime: '2026-10-15T08:05:00',
    views: 152980,
  },
  {
    id: '100003',
    title: '知名连锁餐饮后厨卫生问题被暗访曝光，监管已介入',
    excerpt:
      '一段针对某知名连锁餐饮品牌的暗访视频在网络流传，视频显示其后厨存在食材过期、操作不规范等问题，当地市场监管部门已介入调查。',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20documentary%20style%20photography%20of%20a%20stainless%20steel%20kitchen%20counter%20with%20cold%20grey%20tones%20and%20a%20single%20warm%20overhead%20lamp%2C%20sterile%20clinical%20atmosphere%2C%20sharp%20detail%2C%20clean%20editorial%20composition%20for%20a%20social%20news%20cover&width=800&height=500&seq=blackliao-news-03&orientation=landscape',
    content: [
      '一段时长约六分钟的暗访视频在多个平台流传，拍摄者以顾客身份进入某知名连锁餐饮品牌的加盟门店后厨，记录了食材存放、加工与清洁的全过程。',
      '视频中最受争议的片段显示，部分冷藏食材的标签日期已经过期，但店员仍继续使用；此外，操作台与地面的清洁频率也明显低于行业标准。视频发布后数小时内播放量突破百万。',
      '该品牌总部随后发布声明，表示已第一时间成立专项小组，对涉事门店进行停业整顿，并配合当地市场监管部门的调查。声明同时强调将对全国门店开展为期一个月的自查。',
      '食品安全专家提醒消费者，连锁品牌的加盟门店在管理上往往存在标准执行不一致的问题，遇到异常可保留凭证并向监管部门投诉，切勿仅凭情绪在网络上传播未经核实的信息。',
    ],
    category: '社会热点',
    categorySlug: 'society',
    tags: ['食品安全', '消费维权'],
    source: '民生调查组',
    publishTime: '2026-10-15T07:40:00',
    views: 98760,
  },
  {
    id: '100004',
    title: '两部大制作剧集争抢黄金档期，番位之争由幕后蔓延至台前',
    excerpt:
      '两部同题材大制作剧集被曝同时锁定同一黄金档期，双方主演粉丝就“番位”与资源分配爆发激烈争论，平台方面态度暧昧。',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20cinematic%20photography%20of%20two%20overlapping%20warm%20orange%20spotlights%20crossing%20in%20a%20dark%20charcoal%20theater%20space%2C%20dramatic%20tension%20and%20contrast%2C%20minimal%20elegant%20composition%20for%20an%20entertainment%20industry%20news%20cover&width=800&height=500&seq=blackliao-news-04&orientation=landscape',
    content: [
      '据多位业内人士透露，两部同题材的大制作剧集原本计划错峰播出，但近期因排期调整，双双将目光锁定在同一黄金档期，直接引爆了持续数周的番位之争。',
      '争议的核心并不只是“谁排前面”，而是背后牵动的招商资源、平台推荐位与演员的商业价值排序。有制片人坦言，番位在行业内部长期被视为一种隐性的地位博弈。',
      '双方粉丝在社交平台上互相喊话，相关话题多次登上热搜。有营销号被指在其中推波助澜，通过制造对立来获取流量。',
      '截至目前，两家出品方均未公开回应档期安排。有分析认为，最终结果取决于平台在广告收益与口碑之间的权衡，而非单纯的粉丝声量。',
    ],
    category: '娱乐黑料',
    categorySlug: 'entertainment',
    tags: ['番位之争', '资本博弈'],
    source: '影视内参',
    publishTime: '2026-10-14T21:15:00',
    views: 76430,
  },
  {
    id: '100005',
    title: '“完美人设”男艺人代言接连解约，人设崩塌疑云笼罩',
    excerpt:
      '长期以“正能量暖男”形象示人的某男艺人，近一个月内接连失去多个品牌合作，业内传出其人设与实际行为存在明显落差。',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20conceptual%20photography%20of%20a%20cracked%20glossy%20surface%20reflecting%20warm%20orange%20light%2C%20symbolizing%20a%20shattered%20public%20image%2C%20deep%20charcoal%20background%2C%20artistic%20minimal%20composition%20for%20an%20entertainment%20news%20cover&width=800&height=500&seq=blackliao-news-05&orientation=landscape',
    content: [
      '近一个月来，某位以“正能量暖男”形象深入人心的男艺人，先后有多个代言品牌在合约到期后选择不再续约，引发外界对其商业价值与人设稳定性的猜测。',
      '一位知情人士称，问题的根源并非某一次具体的负面事件，而是长期合作中暴露出的态度问题，导致部分品牌方对其“表里不一”产生顾虑。',
      '值得注意的是，该艺人团队近期密集安排了多场公益活动与正面采访，被业内人士视为典型的形象修复操作。',
      '公关专家分析，人设本质上是品牌资产的透支机制，一旦真实行为与公众期待差距过大，修复成本将远高于建立成本，这也是越来越多品牌对“完美人设”保持谨慎的原因。',
    ],
    category: '明星爆料',
    categorySlug: 'star',
    tags: ['人设崩塌', '塌房预警', '资本博弈'],
    source: '娱乐深喉',
    publishTime: '2026-10-14T19:50:00',
    views: 132010,
  },
  {
    id: '100006',
    title: '大厂“加班黑幕”遭前员工爆料，内部考核规则引发热议',
    excerpt:
      '一名从某大型科技公司离职的员工发布长文，披露了内部隐性的加班考核规则，称“准点下班会被约谈”，迅速引发职场群体共鸣。',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20photography%20of%20a%20dim%20modern%20office%20corridor%20at%20night%20lit%20by%20a%20single%20warm%20orange%20light%2C%20empty%20desks%20and%20cold%20grey%20tones%2C%20quiet%20melancholic%20mood%2C%20clean%20editorial%20composition%20for%20a%20workplace%20news%20cover&width=800&height=500&seq=blackliao-news-06&orientation=landscape',
    content: [
      '一篇题为《我为什么离开那家公司》的长文在职场社区刷屏。作者自称在某大型科技公司工作三年，详细描述了内部一套“看不见的加班考核规则”。',
      '文中提到，尽管公司对外强调“不鼓励无效加班”，但实际考核中，长期准点下班的员工会在绩效打分时被隐性扣分，甚至被主管约谈。作者称自己曾因连续两周准点下班而收到“态度提醒”。',
      '文章发布后，大量网友在评论区分享类似经历，相关话题迅速登上热搜。也有声音提醒，个体经历并不能代表整个行业，需理性看待。',
      '劳动法专家指出，以隐性考核变相强制加班涉嫌违反相关规定，劳动者应注意保留考勤记录、沟通截图等证据，通过合法渠道维护自身权益。',
    ],
    category: '社会热点',
    categorySlug: 'society',
    tags: ['职场内幕', '网络暴力'],
    source: '职场放大镜',
    publishTime: '2026-10-14T16:30:00',
    views: 87650,
  },
  {
    id: '100007',
    title: '私生饭围堵机场通道事件再起，艺人工作室发声呼吁理性追星',
    excerpt:
      '有旅客在机场拍到数十名私生饭围堵通道、追逐艺人拍摄的画面，现场一度混乱，艺人工作室随后发声明呼吁理性追星。',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20motion%20blur%20photography%20of%20a%20crowded%20airport%20terminal%20hall%20with%20warm%20amber%20lights%20and%20grey%20tones%2C%20anonymized%20silhouettes%20rushing%2C%20disorienting%20cinematic%20mood%2C%20minimal%20editorial%20composition%20for%20a%20news%20cover&width=800&height=500&seq=blackliao-news-07&orientation=landscape',
    content: [
      '随着一位人气艺人的行程被泄露，数十名私生饭在机场到达通道前聚集，试图进行近距离拍摄。现场视频显示，人群一度堵塞了公共通道，普通旅客通行受到明显影响。',
      '有旅客向机场安保反映，却因人群流动性大而难以有效疏导。事后，该艺人工作室发布声明，强烈呼吁粉丝理性追星，并提醒相关行为可能涉嫌扰乱公共秩序。',
      '私生饭问题长期困扰着演艺行业，部分经纪公司甚至不得不为艺人安排“错峰出行”与多重安保。业内呼吁机场、警方与平台形成合力，从源头治理信息泄露。',
      '法律人士提醒，跟踪、偷拍并传播艺人私人行程，可能侵犯其隐私权，情节严重的将承担法律责任。追星热情应当有边界。',
    ],
    category: '明星爆料',
    categorySlug: 'star',
    tags: ['私生饭', '代拍乱象', '网络暴力'],
    source: '娱乐深喉',
    publishTime: '2026-10-14T14:10:00',
    views: 64320,
  },
  {
    id: '100008',
    title: '天价片酬阴阳合同疑云重燃，业内呼吁监管持续加码',
    excerpt:
      '有爆料称某演员在项目中通过拆分合同的方式规避限薪规定，实际片酬远超公开数字，引发对行业“阴阳合同”问题的再度关注。',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20photography%20of%20a%20stack%20of%20blank%20folded%20paper%20contracts%20on%20a%20dark%20charcoal%20desk%20under%20warm%20orange%20side%20light%2C%20financial%20and%20legal%20atmosphere%2C%20sharp%20minimal%20editorial%20composition%20for%20a%20business%20news%20cover&width=800&height=500&seq=blackliao-news-08&orientation=landscape',
    content: [
      '多位业内人士向媒体透露，某位一线演员在参与一部项目时，通过将部分片酬包装成“制片成本”“宣传费用”等方式进行拆分，使得账面数字符合限薪规定，实际收入却大幅超出。',
      '这一操作方式与此前行业多次曝出的“阴阳合同”问题高度相似。有制片人坦言，限薪令在部分项目中形同虚设，区别只在于包装手法是否隐蔽。',
      '监管部门此前已多次强调将对违法违规的薪酬安排依法查处。此次爆料再度将问题推向台前，市场普遍预期相关审查将会趋严。',
      '专家指出，治理天价片酬不仅要堵住合同漏洞，更要从项目分账、税收监管等源头环节入手，才能形成长效机制。',
    ],
    category: '娱乐黑料',
    categorySlug: 'entertainment',
    tags: ['天价片酬', '资本博弈', '职场内幕'],
    source: '影视内参',
    publishTime: '2026-10-14T11:45:00',
    views: 71290,
  },
  {
    id: '100009',
    title: '网红直播间“低俗带货”被约谈，平台专项整治行动启动',
    excerpt:
      '数名头部主播因在直播中使用低俗话术引流被平台约谈，相关账号被限流处理，一场针对直播乱象的专项整治正式拉开帷幕。',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20photography%20of%20a%20smartphone%20on%20a%20tripod%20glowing%20with%20warm%20orange%20ring%20light%20in%20a%20dark%20charcoal%20studio%2C%20live%20streaming%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20clean%20minimal%20editorial%20composition%20for%20a%20tech%20news%20cover&width=800&height=500&seq=blackliao-news-09&orientation=landscape',
    content: [
      '近期，平台方针对直播电商领域的乱象启动专项整治，数名拥有数百万粉丝的头部主播因在直播中使用低俗、夸张甚至带有误导性的话术被约谈。',
      '根据平台通报，相关账号已被采取限流、暂停带货等处理措施。有主播的粉丝对此表示不解，但更多消费者认为整治“早该如此”。',
      '业内人士指出，低俗带货虽然短期内能带来流量，却严重损害了用户体验与平台长期生态，平台此次出手既有监管压力，也有自身商业考量。',
      '消费者权益组织建议，面对直播中的夸张宣传应保持警惕，下单前保留商品页面与直播录屏，遇到货不对板可依法维权。',
    ],
    category: '社会热点',
    categorySlug: 'society',
    tags: ['消费维权', '网络暴力', '城市热点'],
    source: '民生调查组',
    publishTime: '2026-10-14T09:00:00',
    views: 59870,
  },
  {
    id: '100010',
    title: '某综艺“恶意剪辑”争议不断，嘉宾发文控诉被塑造人设',
    excerpt:
      '一位参与某热门综艺录制的嘉宾发文称，节目通过剪辑刻意放大了冲突片段，使其在观众心中被塑造成与本人性格完全不同的形象。',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20photography%20of%20a%20video%20editing%20timeline%20glowing%20on%20a%20dark%20charcoal%20screen%20with%20warm%20orange%20waveforms%2C%20media%20production%20atmosphere%2C%20sharp%20minimal%20editorial%20composition%20for%20a%20media%20news%20cover&width=800&height=500&seq=blackliao-news-10&orientation=landscape',
    content: [
      '一位参与某热门综艺录制的嘉宾在社交平台发布长文，称节目组在后期剪辑中刻意保留了引发争议的片段，删除了前因后果，使其在观众眼中被塑造成“情商低”“爱抬杠”的形象。',
      '该嘉宾表示，录制现场的实际情况与播出内容存在较大出入，自己已就此事与节目组沟通，但未获正面回复。博文发布后迅速获得大量转发。',
      '综艺“恶意剪辑”并非新鲜话题。多位从业者透露，冲突与话题度是综艺流量的核心来源，剪辑往往服务于节目效果而非还原真实。',
      '传媒学者提醒观众，在观看综艺时应有意识地保持媒介素养，将节目内容视为经过加工的叙事产品，而非对现实人物的准确记录。',
    ],
    category: '娱乐黑料',
    categorySlug: 'entertainment',
    tags: ['番位之争', '人设崩塌', '网络暴力'],
    source: '影视内参',
    publishTime: '2026-10-13T22:20:00',
    views: 55140,
  },
  {
    id: '100011',
    title: '明星夫妻被曝分居多月，离婚传闻背后的财产分割成焦点',
    excerpt:
      '一对曾被视作模范的明星夫妻被曝已分居数月，双方经纪团队均未正面否认，围绕名下公司与房产的财产分割问题成为外界关注焦点。',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20photography%20of%20two%20distant%20warm%20orange%20lights%20on%20opposite%20sides%20of%20a%20dark%20charcoal%20room%2C%20symbolizing%20separation%2C%20quiet%20melancholic%20mood%2C%20minimal%20editorial%20composition%20for%20an%20entertainment%20news%20cover&width=800&height=500&seq=blackliao-news-11&orientation=landscape',
    content: [
      '据多位圈内人士透露，一对长期以恩爱形象示人的明星夫妻已分居数月，双方因工作与家庭规划的分歧渐生裂痕。消息传出后，双方经纪团队均未正面否认，进一步加剧了外界的猜测。',
      '值得关注的是，两人婚后共同成立或投资了多家公司，并持有若干不动产，财产结构相对复杂。有律师分析，若进入离婚程序，股权与房产的分割将成为争议核心。',
      '知情人士称，双方目前仍处于协商阶段，均希望以“体面”的方式处理，避免将私事演变为舆论战。',
      '类似案例在演艺圈并不少见。公关从业者表示，明星婚姻的公开处理往往牵动商业合约与品牌形象，因此声明措辞与发布时间都经过精心设计。',
    ],
    category: '明星爆料',
    categorySlug: 'star',
    tags: ['离婚风波', '人设崩塌'],
    source: '娱乐深喉',
    publishTime: '2026-10-13T18:40:00',
    views: 145770,
  },
  {
    id: '100012',
    title: '小区物业“天价维修”被业主集体投诉，账目公开成诉求',
    excerpt:
      '某小区业主发现物业维修费用异常高企，多项支出缺乏明细，业主委员会已集体向有关部门投诉，要求公开完整账目。',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20photography%20of%20a%20residential%20building%20facade%20at%20dusk%20lit%20with%20warm%20orange%20windows%20against%20cool%20grey%20tones%2C%20urban%20community%20atmosphere%2C%20clean%20minimal%20editorial%20composition%20for%20a%20city%20news%20cover&width=800&height=500&seq=blackliao-news-12&orientation=landscape',
    content: [
      '某小区业主在核对年度物业公示时发现，小区公共区域的维修支出较往年大幅增加，部分项目单价明显高于市场水平，而对应的明细与合同却始终未能提供。',
      '多位业主表示，他们曾多次向物业索要完整的采购凭证与招标记录，均被以“商业机密”为由拒绝。业主委员会已集体向住建与市场监管部门提交投诉材料。',
      '有法律人士指出，物业费的收支明细属于业主知情权的范围，物业公司无正当理由拒绝公开，业主可通过诉讼或行政投诉途径主张权利。',
      '此事也引发了对社区治理机制的讨论。专家认为，健全的业主大会与公开透明的账目制度，是避免此类纠纷的关键。',
    ],
    category: '社会热点',
    categorySlug: 'society',
    tags: ['消费维权', '城市热点'],
    source: '民生调查组',
    publishTime: '2026-10-13T15:25:00',
    views: 43260,
  },
  {
    id: '100013',
    title: '新晋小花被指资源全靠“带资进组”，经纪公司发声明维权',
    excerpt:
      '一位新晋人气小花被爆料称其角色全部依靠资本运作获得，其经纪公司随即发布声明，否认相关说法并表示将追究造谣者责任。',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20photography%20of%20a%20young%20feminine%20silhouette%20against%20warm%20orange%20backlight%20in%20a%20dark%20charcoal%20space%2C%20anonymized%20and%20artistic%2C%20cinematic%20contrast%2C%20minimal%20editorial%20composition%20for%20an%20entertainment%20news%20cover&width=800&height=500&seq=blackliao-news-13&orientation=landscape',
    content: [
      '一段匿名爆料帖称，某新晋人气小花的多个重要角色均是依靠“带资进组”的方式获得，并列举了数个项目的投资方与出品方关联。帖子迅速引发讨论。',
      '该小花的经纪公司随即发布声明，称相关内容为恶意捏造，严重损害艺人名誉，已委托律师取证并将依法追究责任。声明同时呼吁网友不信谣、不传谣。',
      '有制片人表示，“带资进组”在行业内确实存在，但并非所有新人获得资源都源于此，将个案泛化解读容易误伤努力的年轻演员。',
      '目前爆料帖的原发布者已删除内容，相关话题热度有所回落。事件也再次引发外界对娱乐行业资源分配公平性的讨论。',
    ],
    category: '明星爆料',
    categorySlug: 'star',
    tags: ['资本博弈', '网络暴力', '塌房预警'],
    source: '娱乐深喉',
    publishTime: '2026-10-13T12:00:00',
    views: 48910,
  },
  {
    id: '100014',
    title: '代拍产业乱象调查：一张偷拍照背后的灰色链条',
    excerpt:
      '从机场到剧组外景地，“代拍”群体形成了一条完整的灰色链条，他们通过贩卖艺人偷拍照获取暴利，也让艺人与路人双双不堪其扰。',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20photography%20of%20a%20long%20telephoto%20camera%20lens%20glinting%20with%20warm%20orange%20light%20against%20a%20dark%20charcoal%20background%2C%20surveillance%20and%20privacy%20theme%2C%20sharp%20minimal%20editorial%20composition%20for%20a%20news%20cover&width=800&height=500&seq=blackliao-news-14&orientation=landscape',
    content: [
      '在机场候机区、剧组外景地甚至酒店门口，总能看到一群手持长焦镜头的“代拍”。他们拍摄艺人未经许可的画面，再通过社交平台与私域渠道出售，形成了一条隐蔽的变现链条。',
      '据业内人士估算，一张热门艺人的独家偷拍照，价格可从数百元到数千元不等，若赶上行程曝光节点，收益更为可观。部分代拍甚至与黄牛、信息贩子形成固定合作。',
      '代拍行为不仅侵犯艺人隐私，也常常扰乱公共秩序，多次引发冲突。有剧组不得不加强外景安保，成本随之上升。',
      '法律层面，未经同意拍摄并传播他人肖像、隐私信息，可能构成侵权。行业呼吁平台加强内容审核，切断代拍照片的变现渠道。',
    ],
    category: '娱乐黑料',
    categorySlug: 'entertainment',
    tags: ['代拍乱象', '私生饭', '网络暴力'],
    source: '黑料观察室',
    publishTime: '2026-10-12T20:30:00',
    views: 39750,
  },
  {
    id: '100015',
    title: '某城市“网红打卡点”安全隐患被曝光，管理方紧急回应',
    excerpt:
      '一处因短视频走红的城市打卡点被曝存在明显安全隐患，人流密集却缺乏基本疏散指引，管理方在舆论压力下紧急作出回应。',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20photography%20of%20a%20wet%20city%20street%20glowing%20with%20warm%20orange%20neon%20reflections%20at%20night%2C%20anonymized%20urban%20scene%2C%20cinematic%20depth%20and%20contrast%2C%20minimal%20editorial%20composition%20for%20a%20city%20news%20cover&width=800&height=500&seq=blackliao-news-15&orientation=landscape',
    content: [
      '一处原本不起眼的城市角落，因短视频平台上的打卡热潮而迅速走红，吸引大量游客前往。然而有市民在体验后指出，该区域人流密集，却缺乏必要的疏散通道与警示标识。',
      '一段拍摄于周末高峰时段的视频显示，狭窄的通道内挤满了举着手机的游客，一旦发生意外后果不堪设想。视频发布后迅速引发当地居民共鸣。',
      '在舆论压力下，属地管理方紧急回应，称已增派安保力量并在关键位置加装隔离与指引，同时研究对高峰时段实施限流。',
      '城市规划学者指出，“网红打卡点”的走红往往超出原有承载设计，如何在流量与安全之间取得平衡，考验着城市管理的精细化水平。',
    ],
    category: '社会热点',
    categorySlug: 'society',
    tags: ['城市热点', '消费维权'],
    source: '民生调查组',
    publishTime: '2026-10-12T17:15:00',
    views: 36480,
  },
];